<ftr-icon class="complex-filter-error__icon" icon="Error" size="ExtraLarge" color="Brand"></ftr-icon>
<span class="complex-filter-error__message">
  Filter options failed to load. Please
  <a href class="link" (click)="$event.preventDefault(); refreshOptions.next()">refresh</a> the page or try again later.
</span>
